import React from 'react';
import PropTypes from 'prop-types';

import { ErrorMessage } from 'react-hook-form';
import Form from 'deltoid/core/Form';

const Error = ({
  errors,
  fieldName,
  ...rest
}) => {

  return (
    <ErrorMessage errors={errors} name={fieldName}>
      {({ message }) => (
        <Form.Message type='error' {...rest}>
          {message}
        </Form.Message>
      )}
    </ErrorMessage>
  );
};

Error.propTypes = {
  errors: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
}

export default Error;
